(() => {
  // --- Locale detection (prefer URL prefix like /en/xxxx) ---
  const getLocaleFromPath = () => {
    const p = window.location.pathname || "/";
    const m = p.match(/^\/([a-z]{2}(?:-[A-Z]{2})?)(\/|$)/);
    return m ? m[1].toLowerCase() : null; // "en" / "th" / "en-us"
  };

  const getLocale = () => {
    return (
      getLocaleFromPath() ||
      (window.Shopify && window.Shopify.locale && String(window.Shopify.locale).toLowerCase()) ||
      (document.documentElement.getAttribute("lang") || "").toLowerCase() ||
      "en"
    );
  };

  // --- Remove locale prefix from path: /en/pages/brands -> /pages/brands ---
  const stripLocalePrefix = (pathname) => {
    if (!pathname) return pathname;
    return pathname.replace(/^\/[a-z]{2}(?:-[A-Z]{2})?(?=\/)/i, "");
  };

  const normalizePath = (href) => {
    if (!href) return "";
    if (href.startsWith("javascript:")) return ""; // headers like javascript:;
    try {
      const u = new URL(href, window.location.origin);
      const clean = stripLocalePrefix(u.pathname).replace(/\/+$/, "");
      return clean || "/";
    } catch {
      const raw = href;
      const path = raw.split("?")[0].split("#")[0];
      const clean = stripLocalePrefix(path).replace(/\/+$/, "");
      return clean || "/";
    }
  };

  // --- Translation dictionary (canonical paths only, no /en prefix) ---
  const DICT = {
    th: {
      "/pages/brands": "แบรนด์",
      "/blogs/projects-events": "ผลงานและกิจกรรม",
      "/pages/contact": "ติดต่อเรา",
      "/pages/about-us": "เกี่ยวกับเรา",
      "/pages/quote-request": "ขอใบเสนอราคา",
      "/pages/mission-vision": "พันธกิจ และวิสัยทัศน์",
      "/pages/headquarters": "ออฟฟิศสำนักงานใหญ่",
      "/pages/manufacturing-facility": "โรงงานผลิตสินค้า",
      "/pages/warehouse": "คลังสินค้า",
      "/pages/stores": "ร้านจำหน่ายสินค้า",
      "/pages/career-opportunities": "ร่วมงานกับเรา",
      "/blogs/blog": "บทความ",
      // ถ้าคุณอยากให้ header "ภาพรวมบริษัท" แปลได้ ต้องใช้ key แบบพิเศษ (ไม่มี href)
      "__header_company_overview__": "ภาพรวมบริษัท"
    },
    en: {
      "/pages/brands": "Brands",
      "/blogs/projects-events": "Projects & Events",
      "/pages/contact": "Contact",
      "/pages/about-us": "About Us",
      "/pages/quote-request": "Request a Quote",
      "/pages/mission-vision": "Mission & Vision",
      "/pages/headquarters": "Headquarters Office",
      "/pages/manufacturing-facility": "Manufacturing Facility",
      "/pages/warehouse": "Warehouse",
      "/pages/stores": "Stores",
      "/pages/career-opportunities": "Careers",
      "/blogs/blog": "Blog",
      "__header_company_overview__": "Company Overview"
    }
  };

  const TEXT_FALLBACK = {
  th: {
    "Uniforms & Tactical Gear": "เครื่องแบบ อุปกรณ์ยุทธวิธี",
    "Training & Tactical Gear": "อุปกรณ์ฝึกยุทธวิธี",
    "Tactical Medical": "อุปกรณ์แพทย์ยุทธวิธี",
    "Weapon Accessories": "อุปกรณ์ประกอบอาวุธ",
    "Night Vision": "กล้องส่องกลางคืน"
  },
  en: {
    "เครื่องแบบ อุปกรณ์ยุทธวิธี": "Uniforms & Tactical Gear",
    "อุปกรณ์ฝึกยุทธวิธี": "Training & Tactical Gear",
    "อุปกรณ์แพทย์ยุทธวิธี": "Tactical Medical",
    "อุปกรณ์ประกอบอาวุธ": "Weapon Accessories",
    "กล้องส่องกลางคืน": "Night Vision"
  }
};

  // --- Apply translations ---
  const applyTranslations = () => {
    const locale = getLocale();
    const lang = locale.startsWith("th") ? "th" : "en"; // รองรับ en-us, th-th
    const map = DICT[lang] || DICT.en;

    // 1) ลิงก์ที่มี href จริง
    document.querySelectorAll(".tmenu_nav a.tmenu_item_link").forEach((a) => {
      const path = normalizePath(a.getAttribute("href") || "");
      if (!path) return;

      const newText = map[path];
      if (!newText) return;

      const span = a.querySelector(".tmenu_item_text");
      if (span && span.textContent.trim() !== newText) {
        span.textContent = newText;
      }
      if ((a.getAttribute("title") || "").trim() !== newText) {
        a.setAttribute("title", newText);
      }
    });

    // 2) กรณี header ที่ href="javascript:;" (ไม่มี path ให้ map)
    // ใช้วิธีจับจาก text เดิม แล้วแทนด้วย key พิเศษ
    document.querySelectorAll('.tmenu_nav a.tmenu_item_link[href^="javascript:"]').forEach((a) => {
      const span = a.querySelector(".tmenu_item_text");
      if (!span) return;

      const t = span.textContent.trim();
      if (t === "ภาพรวมบริษัท" || t === "Company Overview") {
        const newText = map["__header_company_overview__"];
        if (newText && t !== newText) span.textContent = newText;
        if (newText && a.getAttribute("title") !== newText) a.setAttribute("title", newText);
      }
    });

      // 3) Fallback: translate by exact text (for headings/no-href items)
const textMap = TEXT_FALLBACK[lang] || {};
document.querySelectorAll(".tmenu_nav .tmenu_item_text").forEach((span) => {
  const oldText = (span.textContent || "").trim();
  const newText = textMap[oldText];
  if (newText && newText !== oldText) {
    span.textContent = newText;

    // update title on parent link if exists
    const a = span.closest("a");
    if (a) a.setAttribute("title", newText);
  }
});
  };



  // --- Throttled observer (apps often re-render) ---
  let scheduled = false;
  const scheduleApply = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      applyTranslations();
    });
  };

  // First run
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => scheduleApply());
  } else {
    scheduleApply();
  }

  // Observe changes
  const observer = new MutationObserver(() => scheduleApply());
  observer.observe(document.documentElement, { childList: true, subtree: true });

  // Also run after full load (บางแอปโหลดช้า)
  window.addEventListener("load", () => scheduleApply());
})();